<div class="animated fadeIn home fullMapPage">
    <div class="row">
        <div class="col-12">
            <div class="topPlantingSiteNameWrapper">
                <div class="topPlantingSiteName">
                    {{site.title}}
                    <i [routerLink]="['/embeded', site.id, showInfo, showMap, showTimeline, showTree, collection.id, 'detail', activePhoto.id]"
                       class="icon-size-actual icons"></i>
                </div>
            </div>

            <div class="contentWrapperTop bgfilter" style="height: unset;">
                <div class="contentDate">{{collection.date | date: 'MM/yyyy'}}</div>
                <div class=" field-content">{{site.country}}{{site.region ? ', ' + site.region: ''}}</div>
                <div class="field-content ">{{site.totalTrees | number}} trees planted in {{site.plantingDate | date: 'yyyy'}}</div>
                <div class="field-content" *ngIf="site.availableTrees > 0; else notAvailable">
                    {{site.availableTrees | number}} trees available
                </div>
                <ng-template #notAvailable>
                    <div class="field-content">Fully sponsored</div>
                </ng-template>
            </div>

            <div class="mapouter">
                <div class="gmap_canvas">
                    <agm-map [disableDoubleClickZoom]="true"
                             [streetViewControl]="false"
                             [mapTypeControlOptions]="{position: mapControlPosition}"
                             [maxZoom]="17"
                             [mapTypeId]="mapTypeId"
                             [mapTypeControl]='true'
                             [fitBounds]="true">
                        <agm-marker *ngFor="let photo of collection.photos"
                                    [agmFitBounds]="true"
                                    (markerClick)="navigateToPhoto(photo)"
                                    [latitude]="photo.lat"
                                    [longitude]="photo.lon"
                                    [iconUrl]="photo === activePhoto ? focusedPinUrl : pinUrl">
                            <agm-snazzy-info-window [openOnMarkerClick]="true"
                                                    [closeWhenOthersOpen]="true"
                                                    [border]="false"
                                                    [pointer]="false"
                                                    [isOpen]="photo == activePhoto"
                                                    [showCloseButton]="false">
                                <ng-template>
                                    <div class="imageOnMapWrapper" style="position: relative;" (click)="fullImgModal.show()">
                                        <div class="imageOnMapBg">
                                            <div class="imageOnMap">
                                                <img class="imageShow" [src]="photo.thumbnailUrl" />
                                            </div>
                                            <div class="imageContent">
                                                <span class="location">{{activePhoto.lat | number: '.0-7'}}, {{activePhoto.lon | number: '.0-7'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </agm-snazzy-info-window>
                        </agm-marker>
                        <agm-kml-layer [url]="siteArea.kmlUrl"></agm-kml-layer>
                    </agm-map>
                </div>
            </div>

            <div class="contentWrapperBottom bgfilter">
                <div class="field-contentLeft">
                    <div class="contentDate">{{collection.date | date: 'MM/yyyy'}}</div>
                    <div class=" field-content">{{site.country}}{{site.region ? ', ' + site.region: ''}}</div>
                </div>
                <div class="field-contentRight">
                    <div class="field-content">{{site.totalTrees | number}} trees planted in {{site.plantingDate | date: 'yyyy'}}</div>
                    <div class="field-content">{{site.availableTrees | number}} trees available</div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-collection-dialog #fullImgModal></app-collection-dialog>
